import PurchaseBlock from './PurchaseBlock';

export default PurchaseBlock;
